import { render } from "./MoveCandidates.vue?vue&type=template&id=10c03dfc"
import script from "./MoveCandidates.vue?vue&type=script&lang=js"
export * from "./MoveCandidates.vue?vue&type=script&lang=js"
script.render = render

export default script